export const FLEET_DRIVER_LOGIN_ACCESS_GROUPS = [
  'a_h_transporte',
  'ayar',
  'b_lent_solak',
  'bosch',
  'canan_bildirici',
  'em_taxi',
  'euronyika',
  'fahrschule_frohne',
  'flotilla_gmbh',
  'hamkar_maqsud',
  'helena',
  'helfenbein_kfz',
  'hepsi_markt',
  'ht_handwerkerteam',
  'komfort_drive',
  'mhs_24',
  'minga089',
  'mk_objektplanung',
  'munich_taxi',
  'nike_taxi_1',
  'oliver_worthmann',
  'pflegeteam_ohz',
  'pp_trans_umzuege_und_transporte',
  'silver_cab',
  'sodernix',
  'spang_fischer_natzschka',
  'susanne_hopp',
  't_s_taxiservice',
  'taxi_zdes',
  'done_electronics',
  'jumpin_etaxi_gmbh',
  'grammer_jifeng_automotive_seating',
  'hammonia_taxi',
  'oxylis',
  'fraenkische_landmetzgerei_lindoerfer',
  'bk_nord_taxi',
  'ming_fahrschull',
  'best_taxi_gmbh',
  'bgs',
  'raumakustiks',

  // TODO: remove this after testing
  'driver_pass_test',
  'qa_test',
];
